import {Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import {IRestaurantDistancePriceResponse} from 'types';

import {OrderTotalListItem} from '../order-total-list-item';

interface IProps {
  cartItemsPrice: number;
  t: (term: TranslationKeys) => string;
  dynamicDeliveryPrice: IRestaurantDistancePriceResponse;
  deliveryTime: string;
  hasPreorder?: boolean;
  deliveryAmount: number;
  isMetro?: boolean;
}

export const CostDelivery: FC<IProps> = ({
  t,
  dynamicDeliveryPrice,
  deliveryTime,
  hasPreorder,
  deliveryAmount,
  isMetro,
}) => {
  const {surcharge} = dynamicDeliveryPrice;
  return (
    <OrderTotalListItem
      title={`${t('DELIVERY')} ${
        isMetro && !deliveryTime ? '' : `(${deliveryTime}${!hasPreorder ? ` ${t('MINUTES')}` : ''})`
      }`}
      boxProps={{
        borderBottom: '1px solid #E6E6E6',
        // flexDirection: `${!!deliveryAmount ? 'row' : 'column'}`,
      }}
    >
      <Text as="span" fontWeight="500" color={!deliveryAmount ? colors.green : ''}>
        {deliveryAmount ? `${deliveryAmount + surcharge} ${t('CURRENCY')}` : t('FREE')}
      </Text>
    </OrderTotalListItem>
  );
};
